// extracted by mini-css-extract-plugin
export default {"wrapper":"StickOrRock_wrapper__9S-sY"};